import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getReasonArriveLateStart,
  getReasonArriveLateSuccess,
  getReasonArriveLateFailed,
} from "../redux/getReasonArriveLate";
import { getListReasonArriveLateApi } from "core/http/service/timeKeeping";

function* getReasonArriveLateWork() {
  try {
    const res = yield call(getListReasonArriveLateApi);

    yield put({
      type: getReasonArriveLateSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getReasonArriveLateFailed.type,
    });
  }
}

function* watchGetReasonArriveLate() {
  yield takeLatest(getReasonArriveLateStart.type, getReasonArriveLateWork);
}

export default function* getReasonArriveLateSaga() {
  yield all([watchGetReasonArriveLate()]);
}
